import React, { useState, useEffect } from 'react';

interface PracticeTimerProps {
  isActive: boolean;
  onTimeUpdate?: (seconds: number) => void;
}

const PracticeTimer: React.FC<PracticeTimerProps> = ({ isActive, onTimeUpdate }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (isActive) {
      interval = setInterval(() => {
        setSeconds((prev) => {
          const newSeconds = prev + 1;
          onTimeUpdate?.(newSeconds);
          return newSeconds;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, onTimeUpdate]);

  const formatTime = (totalSeconds: number): string => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="inline-flex items-center gap-2 bg-white dark:bg-slate-700 rounded-full px-4 py-2 shadow-md dark:shadow-slate-900">
      <span className="text-xl">{'\u23F1\uFE0F'}</span>
      <span className="font-bold text-gray-700 dark:text-gray-200 text-lg">{formatTime(seconds)}</span>
    </div>
  );
};

export default PracticeTimer;
